"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _rxjs = require("rxjs");

var _events = require("events");

var _ = require(".");
/* INNER INTERFACE, ONLY USED BY MAIN, NEVER EXPORT TO VIEW */


var emitter = new _events.EventEmitter();

var _default = new _.MainCore(emitter, {
  emit: function emit() {
    emitter.emit.apply(emitter, arguments);
  },
  fullscreen: function fullscreen() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    this.emit.apply(this, ['fullscreen'].concat(args));
  }
}, new _rxjs.Subject());

exports.default = _default;